import { RouteComponentProps } from "polyrouter";
import { Layout } from "views/Main/Layouts";
import { Trans, useTranslation } from "utilities/i18n";
import { Scope, scopeToT, scopeToTSubHeader } from "./PolicyList";
import DefaultDeviceTableViewLoader from "routes/Manage/Inventory/List/TableView";
import {
  usePolicyFilterValue,
  defaultFilterState
} from "elements/Filter/PolicyFilter";
import { useEffect } from "react";

export const PolicyDeviceList: React.FC<RouteComponentProps> = ({ match }) => {
  const { Content } = Layout;
  const { t } = useTranslation();
  const params = match.params as Scope;
  const { scope } = params;
  const [filterState, setFilter] = usePolicyFilterValue();

  useEffect(() => {
    if (filterState.device) {
      setFilter(defaultFilterState);
    }
  }, [setFilter, filterState]);

  return (
    <Content className={`policy ${scope}`}>
      <Content.Title>{t(scopeToT(scope))}</Content.Title>
      <Trans i18nKey={scopeToTSubHeader(scope)}>
        <p className="policy-list-text">
          Click a device name to view that device's policy. Settings applied to
          each policy
          <strong> will only apply to the individual device.</strong>
        </p>
      </Trans>
      <DefaultDeviceTableViewLoader />
    </Content>
  );
};
